import React from 'react'
import './about.css'
import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_1.jpg'
import StoryImage from '../../images/about1.jpg'
import VisionImage from '../../images/about2.jpg'
import MissionImage from '../../images/about3.jpg'


const About = () => {
  return (
  <>
  <Header title="About Us" bredcum={HeaderImage}>
    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure earum ab temporibus possimus delectus laborum quia dolorum vero culpa aspernatur!</p>
    </Header>

  <section className='about__story'>
    <div className="container about__story-container">
      <div className="about__section-image">
        <img src={StoryImage} alt="Our StoryImage" />
      </div>
      <div className="about__section-content">
        <h1>Our Story</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minus veritatis laboriosam alias laborum hic doloremque consequuntur nobis recusandae saepe in is sint numquam commodi! Dolorum deleniti dignissimos eaque voluptates suscipit.</p>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem quam inventore sint nam, nisi sit officia quisquam libero facilis voluptates! Reiciendis quae nihil doloribus olaboriosam. Veniam, non cum.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui exercitationem hic ullam repellat nostrum perspiciatis voluptas laudantium accusamus, doloribus laboriosam!</p>
      </div>
    </div>

  </section>





  <section className='about_Vision'>
    <div className="container about__Vision-container">
    
      <div className="about__section-content">
        <h1>Our Vision</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minus veritatis laboriosam alias laborum hic doloremque consequuntur nobis recusandae saepe in inventore aperiam perferendis, similique aspernatur ab veniam, mollitia distinctio maiores sint numquam commodi! Dolorum deleniti dignissimos eaque voluptates suscipit.</p>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem quam inventore sint nam, nisi sit officia quisquam libero facilis voluptates! Reiciendis quae nihil doloribus officiis, ab commodi, fuga id, ex provident perferendis atque repellendus nemo veritatis laboriosam. Veniam, non cum.</p>
       
      </div>
      <div className="about__section-image">
        <img src={VisionImage} alt="Our VisionImage" />
      </div>
    </div>

  </section>






  <section className='about__mission'>
    <div className="container about__mission-container">
      <div className="about__section-image">
        <img src={MissionImage} alt="Our missionImage" />
      </div>
      <div className="about__section-content">
        <h1>Our Mission</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat minus veritatis laboriosam alias laborum hic doloremque consequuntur nobis recusandaperiam perferendis, similiint .</p>

        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem quam inventore sint nam, nisi sit officia quisquam libero facilis voluptates! Reiciendis quae nihil veritatis laboriosam. Veniam, non cum.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui exercitationem hic ullam repellat nostrum pers</p>
      </div>
    </div>

  </section>
  </>
  )
}

export default About